import { Validators, ValidatorFn } from '@angular/forms';
import { collections } from '../../constants/collections';
import { AbstractFormControl } from '../abstract-form-control';

export class OtpFormControl extends AbstractFormControl {
  constructor(
    required: boolean = false,
    disabled: boolean = false,
    private options?: OtpOptions
  ) {
    super(required, disabled, { updateOn: 'change' });
    this.setValue(null);
  }

  get length(): number {
    return this.options?.length ?? 6;
  }

  get hideErrorMessages(): boolean {
    return this.options?.hideErrorMessages ?? false;
  }

  get requiredErrorMessage(): string {
    return this.options?.requiredErrorMessage ?? collections.messages.required;
  }

  get incorrectErrorMessage(): string {
    return this.options?.incorrectErrorMessage ?? `Le code doit comporter ${this.length} chiffres.`;
  }

  protected getValidators(): ValidatorFn[] {
    return [Validators.pattern(new RegExp(`^\\d{${this.length}}$`))];
  }
}

export interface OtpOptions {
  hideErrorMessages?: boolean;
  incorrectErrorMessage?: string;
  length?: number;
  requiredErrorMessage?: string;
}